import { render, staticRenderFns } from "./catalog-load-more.vue?vue&type=template&id=f21dfb82&scoped=true"
import script from "./catalog-load-more.vue?vue&type=script&lang=js"
export * from "./catalog-load-more.vue?vue&type=script&lang=js"
import style0 from "./catalog-load-more.vue?vue&type=style&index=0&id=f21dfb82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21dfb82",
  null
  
)

export default component.exports